module.exports = __webpack_public_path__ + "static/media/trabajo-en-equipo.e653586e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svg/trabajo-en-equipo.svg
// module id = 195
// module chunks = 0